// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-input[data-v-83b50b9e]  .el-input__inner {\n  min-width: 350px;\n}", ""]);
// Exports
module.exports = exports;
